<template>
    <div id="write_testimonial" class="write-testimonial">
        <b-form @submit="submit" class="p-2">
            <b-col>
                <b-form-group>
                    <b-form-input id="text" name="nickname" placeholder="Nickname" required
                                  v-model="testimonial.user_nickname">
                    </b-form-input>
                </b-form-group>
                <b-form-group>
                    <vue-editor v-model="testimonial.text"></vue-editor>
                </b-form-group>
                <b-button type="submit" variant="primary" @click.stop="submit">Submit</b-button>
            </b-col>
        </b-form>
        <!-- Loading element -->
        <div id="loading" class="loading" v-if="isLoading">
            <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>

<script>

export default {
    name: 'write-testimonial',

    props: {
        agent: {
            type: Object,
            default: () => {
            }
        },
    },

    data() {
        return {
            isLoading : false,
            testimonial: {
                text: null,
                user_nickname: null,
                agent_id: this.agent.id,
            },
        }
    },
    methods: {
        submit(evt) {
            evt.preventDefault();
            let _self = this;
            let endpoint = '/api/agents/testimonial';
            let data = {
                testimonial: _self.testimonial
            };
            _self.isLoading = true;
            axios.post(endpoint, data)
                .then(function (response) {
                    _self.isLoading = false;
                    if (response.data.status === false) {
                        _self.$eventHub.$emit('testimonial::added', "success");
                    } else {
                        _self.$eventHub.$emit('testimonial::added', "success");
                    }
                });
        }
    },
}

</script>

<style lang="scss">
#loading {
    background: rgba(255, 255, 255, 0.6);
    position: fixed;
    height: 100vh;
    width: 100vw;
    z-index: 10010;
    top: 0;
    left: 0;
    text-align: center;
}

#loading i {
    Position: absolute;
    Top: 50%;
    Transform: translateY(-50%);
}

</style>
